import React, { useCallback, useState } from "react";
import { MdCached, MdLink } from "react-icons/md";
import { useIntl } from "react-intl";
import { linkCarToOperation } from "~/api";
import { useOperation } from "~/hooks/useOperation";
import { formatNumber } from "~/utils/format";

const UnlinkedCar = ({ car, reload, setError }) => {
  const { operation } = useOperation();
  const { formatMessage } = useIntl();

  const [isLinkingCar, setIsLinkingCar] = useState(false);

  const downloadAndLinkCar = useCallback(async () => {
    setIsLinkingCar(true);

    try {
      await linkCarToOperation({
        b3_proposta_id: operation.id,
        numero_car: car.cod_imovel,
      });
    } catch (e) {
      setError(formatMessage({ id: "erro-api" }));
      setIsLinkingCar(false);
      return;
    }

    reload();
  }, [
    car,
    operation.id,
    reload,
    formatMessage,
    setError
  ]);

  return (
    <div className="selected-car">
      <p className="selected-car-header">
        {formatMessage({ id: "detalhes-car-detectado" })}
      </p>

      <p>
        <strong>{formatMessage({ id: "numero-car" })}:</strong> {car.cod_imovel}
      </p>
      <p>
        <strong>{formatMessage({ id: "situacao-cadastro" })}:</strong> {car.ind_status}
      </p>
      <p>
        <strong>{formatMessage({ id: "condicao-cadastro" })}:</strong> {car.des_condic}
      </p>
      <p>
        <strong>{formatMessage({ id: "area-car" })}:</strong>{" "}
        {formatNumber(car.num_area)} ha
      </p>
      <p>
        <strong>{formatMessage({ id: "tipo-imovel" })}:</strong>{" "}
        {car.ind_tipo}
      </p>
      <p>
        <strong>{formatMessage({ id: "modulos-fiscais" })}:</strong>{" "}
        {car.mod_fiscal}
      </p>
      <p>
        <strong>{formatMessage({ id: "area-intersecao" })}:</strong>{" "}
        {formatNumber(car.area_ha_intersecao)} ha
      </p>

      <div className="spacing" />

      <p className="selected-car-header">
        {formatMessage({ id: "vincular-car" })}
      </p>
      <p>{formatMessage({ id: "clique-captcha-para-vincular-car" })}</p>
      <div className="link-car-button-wrapper">
        <button 
          disabled={isLinkingCar}
          className="link-car-button" onClick={downloadAndLinkCar}
        >
          <MdLink size={20} /> {formatMessage({ id: "vincular" })}
        </button>

        {isLinkingCar && (
          <div>
            <MdCached size={16} className="loader-only-rotation" />
          </div>
        )}
      </div>
    </div>
  );
};

export default UnlinkedCar;
